<ion-card>
  <ion-card-header class="header">
    {{ HEADER }}
  </ion-card-header>

  <ion-card-content class="content">
    <!-- First Row (Access Point Name, UAP ID, Phone No.)-->
    <ion-grid class="grid">
      <ion-row>
        @for (data of rowData[0]; track data; let i = $index) {
          <ion-col [size]="FIRST_ROW[i].size">
            <div class="row-header">{{ FIRST_ROW[i].label }}</div>
            <div class="row-data">{{ data }}</div>
          </ion-col>
        }
      </ion-row>
      <hr />
    </ion-grid>
    <!---------------------------->

    <!-- Second Row (Address, City,Province, Postal Code, Country)-->
    <ion-grid class="grid">
      <ion-row>
        @for (row of rowData[1]; track row; let i = $index) {
          <ion-col [size]="SECOND_ROW[i].size">
            <div class="row-header">{{ SECOND_ROW[i].label }}</div>
            <div class="row-data">{{ row ? row : "-" }}</div>
          </ion-col>
        }
      </ion-row>
    </ion-grid>
    <!---------------------------->

    <!-- Third Row Lat/Long, Prox Radius)-->
    <ion-grid class="grid">
      <ion-row class="ion-padding-top">
        @for (row of rowData[2]; track row; let i = $index) {
          <ion-col [size]="THIRD_ROW[i].size">
            <div class="row-header">{{ THIRD_ROW[i].label }}</div>
            <div class="row-data">{{ row ? row : "-" }}</div>
          </ion-col>
        }
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>
